import { Link, useFetcher } from "react-router"
import { removeFromCartIntent } from "#app/routes/_marketing+/cart"
import { getProductImgSrc, price } from "#app/utils/misc"
import routes from "#routes"
import Loader from "../loader"
import LoaderImage from "../loader-image"
import { Button } from "../ui/button"
import { Icon } from "../ui/icon"
import { TypographyMuted, TypographyP } from "../ui/typography"

export default function ItemsTable({
	items,
	canDelete = false,
}: {
	items: {
		id: string
		quantity: number
		productVariantId: string | null
		product: {
			name: string
			price: number
			id: string
			handle: string
			images: {
				id: string
				altText: string | null
			}[]
			variants: {
				id: string
				title: string
				price: number
			}[]
		}
	}[]
	canDelete?: boolean
}) {
	const fetcher = useFetcher()
	return items.map(item => {
		const variant = item.product.variants.find(
			v => v.id === item.productVariantId,
		)

		return (
			<div key={item.id} className="flex items-center justify-between gap-2">
				<Link
					to={routes.public.product.route(item.product.handle)}
					className="flex flex-1 items-center gap-2 md:gap-4"
				>
					<div className="w-[50px] sm:w-[75px] md:w-[100px]">
						<LoaderImage
							src={getProductImgSrc(item.product.images[0]?.id ?? "")}
							alt={item.product.images[0]?.altText ?? item.product.name}
						/>
					</div>
					<div className="flex flex-col gap-0.5 sm:gap-1 md:gap-1.5">
						<TypographyP>{item.product.name}</TypographyP>
						{variant && (
							<TypographyMuted>Variante: {variant.title}</TypographyMuted>
						)}
						<div className="flex items-center gap-1">
							<TypographyMuted>{item.quantity}</TypographyMuted>
							<TypographyMuted>-</TypographyMuted>
							<TypographyMuted>
								{variant ? price(variant.price) : price(item.product.price)}
							</TypographyMuted>
						</div>
					</div>
				</Link>

				{canDelete && (
					<div className="relative flex min-w-[24px] items-center justify-end">
						<fetcher.Form method="POST" action="/cart">
							<input type="hidden" name="cartItemId" value={item.id} />
							<Button
								type="submit"
								name="intent"
								value={removeFromCartIntent}
								className="flex items-center justify-center"
								variant="ghost"
								title={`Eliminar todos los "${item.product.name}" del carrito.`}
							>
								{fetcher.state === "loading" ||
								fetcher.state === "submitting" ? (
									<Loader />
								) : (
									<Icon name="lucide-trash" size="sm" />
								)}
							</Button>
						</fetcher.Form>
					</div>
				)}
			</div>
		)
	})
}
